export const SESSION_STORAGE_KEYS = {
  DASHBOARD_TAB_ID: 'dashboardTabId',
  IMPERSONATION_USER: 'impersonationUser',
};
